export const PRICE = '800 грн'
